module.exports = __webpack_public_path__ + "img/tipping-truck.7046267.png";